export default "__VITE_ASSET__B7_eZO9Z__"